import { NavLink } from 'react-router-dom';
import { useTopicsListQuery } from '../../../store/chatbox/chatboxApi';
import { useTheme } from '../../../utils/theme-context';

const ChatHistory = () => {
	const { theme } = useTheme();
	const { data, isLoading } = useTopicsListQuery();

	return (
		<>
			{(data?.data.elements.length === 0 && !isLoading) && <p>No chats on history</p>}
			{data?.data.elements.map(chat => (
				<NavLink
					key={chat._id}
					className='w-full mb-2 flex flex-row items-center border border-gray-100 dark:border-primary-darkMode text-gray-900 dark: text-sm p-2 hover:opacity-80'
					to={`/staff/chat?topicId=${chat._id}`}
				>
					<img alt='chat' className='mr-2 object-contain w-[20px]' src={theme === 'dark' ? '/svg/icons/chat-icon-white.svg' : '/svg/icons/chat.svg'} />
					<span className='dark:text-primary-darkMode'>{chat.name} - {chat.inputFields?.cabinId} </span>
				</NavLink>
			))}

		</>
	)
}

export default ChatHistory;

